import React, { useState, useEffect } from 'react'
import SingleProduct from '../Product/SingleProduct'
import headphone from '../../assets/homepage_ps7.png'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import axios from 'axios'
import BaseApi from '../../Core/BaseApi';
import Product from '../../Entity/Product'



import product from '../../Entity/Product'
import BaseViewModel from '../../Core/BaseViewModel'
import NewArrivalDataService, { NewArrivalGetAllRequestEntity } from '../../DataAccess/NewArrivalDataService'

import BaseComponent from '../../Core/BaseComponent'
import BaseState from '../../Core/BaseState'

export class NewArrivalsViewModel extends BaseViewModel {
  ProductList: product[] = [];
}
const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0,
}
export default class NewArrivals extends BaseComponent<any, NewArrivalsViewModel> {
  constructor(props: any) {
    super(props);
    this.state = new BaseState(new NewArrivalsViewModel())
  }
  componentDidMount() {
    this.ClearForm();
  }
  ClearForm = async () => {
    this.UpdateViewModelUnknown(new NewArrivalsViewModel());

    this.LoadProductBrandList();

  }
  
  LoadProductBrandList = async () => {
    var model = this.state.Model
    
    this.ShowTableLoader(true);
     
    var res = await NewArrivalDataService.GetAll()
    this.ShowTableLoader(false);
    this.ProcessResponseData(res, false);
    if (!res.IsSuccess) {
      return;
    }
    model.ProductList = res.Data as Product[];

    this.UpdateViewModel();

  }



  render() {
    var model = this.state.Model;
    return (
      <>
        <Slider {...sliderSettings}>
          {model.ProductList?.map((i: Product, index: any) => (
            <div className="item" key={index}>
              <div className="pro-bx" style={{ marginBottom: '40px' }}>
                <h4>{}</h4>
                <h3>{i.Name}</h3>
                <div className="prod-img mt-0 p-0">
                  <span className="tag6">stock <span>{i.Pieces}</span></span>
                  <img className="img-fluid" src={''} alt="" />
                  <a
                    href="#"
                    className="btn-quick"
                    data-toggle="modal"
                    data-target="#quickview"
                  >
                    Quick View
                  </a>
                </div>
                <div className="price-prt2">
                  <h5>$245.00</h5>
                </div>
                <div className="f-prt">
                  <a href="#" className="wish" data-toggle="tooltip" title="Wishlist">
                    <i className="fa fa-heart-o" />
                  </a>
                  <a className="btn-cart" href="#">
                    ADD TO CART
                  </a>
                  <a
                    href="#"
                    className="compare"
                    data-placement="top"
                    data-toggle="tooltip"
                    title="Compare"
                  >
                    <i className="fa fa-refresh" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </>
    )
  }
}

